import React from 'react';
import styles from './index.css';

/**
 * 定义 SearchTop 组件
 */
class SearchTop extends React.PureComponent {
    clickSearch = () => {
        const searchValue = this.refs.searchValue.value;

        if (searchValue) {
            const searchHref = '//search.ifeng.com/sofeng/search.action?q=';

            window.open(`${searchHref}${searchValue}&c=1`);
        }
    };
    keyDownSearch = e => {
        if (e.keyCode === 13) {
            const searchValue = this.refs.searchValue.value;

            if (searchValue) {
                const searchHref = '//search.ifeng.com/sofeng/search.action?q=';

                window.open(`${searchHref}${searchValue}&c=1`);
            }
        }
    };
    /**
     * 渲染组件
     */
    render() {
        return (
            <div className={styles.search}>
                <input type="text" className={styles.searchInput} ref="searchValue" onKeyDown={this.keyDownSearch} />
                <button className={styles.searchBtn} onClick={this.clickSearch}>
                    搜索
                </button>
            </div>
        );
    }
}

export { SearchTop };
export default SearchTop;
